import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { SessionService } from '../../../core/auth/session.service';
import { Lang, LanguageService } from '../../../core/i18n/language.service';

/** EN | عربي switch. Ids: `{elementId}-en-btn`, `{elementId}-ar-btn`. */
@Component({
  selector: 'app-language-switch',
  imports: [TranslocoPipe],
  templateUrl: './language-switch.html',
  styleUrl: './language-switch.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSwitch {
  protected readonly language = inject(LanguageService);
  private readonly session = inject(SessionService);

  readonly elementId = input.required<string>();

  protected use(lang: Lang): void {
    if (lang === this.language.lang()) return;
    this.language.use(lang);
    // The API labels the role in the request language (`Accept-Language`), so fetch it again.
    void this.session.refreshUser();
  }
}
